import SEO from "../../../../src/components/seo";
import Chartilisari from "../../../../src/components/chartilisari";
import * as React from 'react';
export default {
  SEO,
  Chartilisari,
  React
};